import React, { useCallback, useState } from 'react';

import { deleteDoc, doc, getDoc, updateDoc } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { FaTrash } from 'react-icons/fa';

import Button from 'components/Button';
import { Review } from 'interfaces/Review';
import { db } from 'services/firebase';

import {
  Container,
  ReviewHeader,
  ReviewAuthor,
  ReviewVeredict,
  ReviewMessage,
} from './styles';

interface EditReviewProps {
  review: Review;
  index: number;
  setReviews: React.Dispatch<React.SetStateAction<Review[]>>;
}

const EditReview: React.FC<EditReviewProps> = ({
  review,
  index,
  setReviews,
}) => {
  const [authorName, setAuthorName] = useState(review.author.name);
  const [positive, setPositive] = useState(review.positive);
  const [message, setMessage] = useState(review.message);

  const updateReview = useCallback(async () => {
    try {
      const reviewRef = doc(
        db,
        `services/${review.serviceId}/reviews`,
        review.id,
      );
      const reviewData = (await getDoc(reviewRef)).data() as Review;

      await updateDoc(reviewRef, {
        author: {
          id: reviewData.author.id,
          name: authorName,
        },
        message,
        positive,
      });

      toast.success('Indicação atualizada com sucesso');
    } catch (err) {
      toast.error(
        `Erro ao atualizar Indicação.\nCausa: ${(err as Error).message}`,
      );
    }
  }, [authorName, message, positive, review.id, review.serviceId]);

  const deleteReview = useCallback(async () => {
    try {
      const reviewRef = doc(
        db,
        `services/${review.serviceId}/reviews`,
        review.id,
      );

      await deleteDoc(reviewRef);

      setReviews((reviews) =>
        reviews.slice(0, index).concat(reviews.slice(index + 1)),
      );

      toast.success('Indicação removida com sucesso');
    } catch (err) {
      toast.error(
        `Erro ao remover Indicação.\nCausa: ${(err as Error).message}`,
      );
    }
  }, [index, review.id, review.serviceId, setReviews]);

  return (
    <Container>
      <ReviewHeader>
        <div>
          <div>
            <label htmlFor="author">Autor: </label>
            <ReviewAuthor
              id="author"
              type="text"
              value={authorName}
              onChange={(e) => setAuthorName(e.target.value)}
            />
          </div>
          <div>
            <label htmlFor="positive">Avaliação positiva: </label>
            <ReviewVeredict
              id="positive"
              type="checkbox"
              checked={positive}
              onChange={() => setPositive(!positive)}
            />
          </div>
        </div>
        <FaTrash size={30} onClick={deleteReview} />
      </ReviewHeader>
      <br />
      <label htmlFor="message">Mensagem:</label>
      <ReviewMessage
        id="message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <Button type="button" onClick={updateReview}>
        Salvar
      </Button>
    </Container>
  );
};

export default EditReview;
